import { ButtonHTMLAttributes, PropsWithChildren } from 'react'
import styles from './Button.module.scss'
import { classNames } from '@/src/helpers/component'
import SVGChevron from '@/src/components/common/SVG/SVGChevron'
import { CustomSVGWithDirection } from '@/src/components/common/SVG/SVG'

export default function ButtonClient({
  children,
  chevron,
  ...props
}: PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    chevron?: CustomSVGWithDirection['direction']
  }
>) {
  return (
    <button {...props} className={classNames(styles.container, styles.inverse, props.className)}>
      {children}
      {chevron && <SVGChevron fill={'currentColor'} direction={chevron} />}
    </button>
  )
}
